/**
 * DAMarketDataService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DAMarketDataService {
    getMarketDataForCompany = (body) => {
        return apiClient.post("/dataAnalysis/marketData", body);
    }
}
